import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import { FaChild, FaUsers, FaUserTie, FaArrowLeft } from 'react-icons/fa';
import image4 from '../../Assets/image 4.png';
import image5 from '../../Assets/image 5.png';
import image6 from '../../Assets/image 6.png';

const LifeStage = () => {
  const navigate = useNavigate();

  const ministryAreas = [
    {
      id: 1,
      icon: <FaChild className="text-3xl text-purple-500" />,
      title: 'Children\'s Ministry (Ages 0-12)',
      description: 'Nurturing young hearts to know Jesus through age-appropriate worship, Bible stories, creative activities, and safe environments where children can encounter God\'s love.',
      image: image4,
      programs: [
        'Sunday School Classes for all ages.',
        'Children\'s worship during services.',
        'Special events and holiday celebrations.'
      ]
    },
    {
      id: 2,
      icon: <FaUsers className="text-3xl text-orange-500" />,
      title: 'Youth\'s Ministry (Ages 13-18)',
      description: 'Empowering teenagers to discover their identity in Christ through dynamic worship, relevant teaching, mentorship, and opportunities to serve and reach.',
      image: image5,
      programs: [
        'Sunday evening youth services',
        'Mission trips and retreats',
        'Community service projects.',
        'Leadership development programs'
      ]
    },
    {
      id: 3,
      icon: <FaUserTie className="text-3xl text-teal-500" />,
      title: 'Adult Ministry (Ages 18+)',
      description: 'Growing together in faith through small groups, Bible studies, fellowship events, and ministry opportunities that build authentic community and spiritual maturity.',
      image: image6,
      programs: [
        'Weekly small group studies',
        'Marriage enrichment classes',
        'Men\'s and women\'s ministry events',
        'Senior adult fellowship activities'
      ]
    }
  ];

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="Ministries"
        subtitle="Discover how you can grow, serve, and connect through our specialized ministries"
        height="h-[500px]"
        contentPosition="bottom"
      />

      {/* Back Button and Content Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          {/* Back Button */}
          <button 
            onClick={() => navigate('/ministries')}
            className="flex items-center gap-2 text-primary hover:text-blue-700 mb-8 font-sf-pro font-medium"
          >
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <FaArrowLeft className="text-white text-sm" />
            </div>
            Back
          </button>

          {/* Title and Description */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Life-Stage Ministries</h2>
            <p className="text-gray-700 text-lg max-w-3xl mx-auto font-sf-pro">
              Ministries designed to meet you where you are in life, providing age-appropriate discipleship and community connection.
            </p>
          </div>

          {/* Ministry Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {ministryAreas.map((area) => (
              <div key={area.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="relative h-48">
                  <img 
                    src={area.image} 
                    alt={area.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    {area.icon}
                    <h3 className="text-lg font-bold">{area.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm font-sf-pro leading-relaxed mb-4">
                    {area.description}
                  </p>
                  <ul className="space-y-2">
                    {area.programs.map((program, index) => (
                      <li key={index} className="flex items-start gap-2 text-sm text-gray-700 font-sf-pro">
                        <span className="text-orange-500 mt-1">●</span>
                        <span>{program}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Button */}
          <div className="flex justify-center">
            <button 
              onClick={() => navigate('/ministries/join')}
              className="bg-black text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-900 transition font-sf-pro"
            >
              Join us
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default LifeStage;
